(function () {
  function getGiftPattern() {
    var value = '';

    try {
      value = new URLSearchParams(window.location.search).get('pattern') || '';
    } catch (error) {
      var match = window.location.search.match(/[?&]pattern=([^&]+)/);
      value = match ? match[1] : '';
    }

    try {
      value = decodeURIComponent(String(value).replace(/\+/g, ' '));
    } catch (error) {
      value = String(value);
    }

    value = value.trim();
    return /^[A-Za-z0-9_-]+$/.test(value) ? value : '';
  }

  function carryGiftPattern() {
    var pattern = getGiftPattern();
    if (!pattern) return;

    document.querySelectorAll('[data-gift-diagnosis-link]').forEach(function (link) {
      try {
        var target = new URL(link.getAttribute('href'), window.location.origin);
        target.searchParams.set('pattern', pattern);
        link.setAttribute('href', target.pathname + target.search + target.hash);
      } catch (error) {
        link.setAttribute('href', '/pages/gift-diagnosis?pattern=' + encodeURIComponent(pattern));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', carryGiftPattern);
  } else {
    carryGiftPattern();
  }
})();
